import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityNotice = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your payment data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'We follow strict European data protection regulations'
    },
    {
      icon: 'CheckCircle',
      title: 'PCI DSS Certified',
      description: 'Payment processing meets industry security standards'
    }
  ];

  return (
    <div className="bg-success/5 rounded-xl p-6 mb-6 border border-success/20">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Shield" size={20} className="text-success" />
        <h4 className="font-medium text-foreground">Secure Payment</h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <Icon name={feature?.icon} size={16} className="text-success mt-1 flex-shrink-0" />
            <div>
              <div className="text-sm font-medium text-foreground">{feature?.title}</div>
              <div className="text-xs text-muted-foreground">{feature?.description}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-success/20">
        <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="CreditCard" size={14} />
            <span>Visa</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="CreditCard" size={14} />
            <span>Mastercard</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Smartphone" size={14} />
            <span>Vipps</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Wallet" size={14} />
            <span>PayPal</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityNotice;